import { render, staticRenderFns } from "./CreateEmployeePlus.vue?vue&type=template&id=66487a0a&scoped=true"
import script from "./CreateEmployeePlus.vue?vue&type=script&lang=js"
export * from "./CreateEmployeePlus.vue?vue&type=script&lang=js"
import style0 from "./CreateEmployeePlus.vue?vue&type=style&index=0&id=66487a0a&lang=css"
import style1 from "./CreateEmployeePlus.vue?vue&type=style&index=1&id=66487a0a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66487a0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66487a0a')) {
      api.createRecord('66487a0a', component.options)
    } else {
      api.reload('66487a0a', component.options)
    }
    module.hot.accept("./CreateEmployeePlus.vue?vue&type=template&id=66487a0a&scoped=true", function () {
      api.rerender('66487a0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employee/CreateEmployeePlus.vue"
export default component.exports